import {ProductPolicy} from "../../providers/product/product-types";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";
import {ProductProps} from "./Product";

export const ProductDetails = ({product}: ProductProps) => {
    return (
        <>
            <div className="mt-10">
                <h2 className="text-sm font-medium text-gray-900">Opis</h2>

                <div
                    className="prose prose-sm mt-4 text-gray-500"
                    dangerouslySetInnerHTML={{__html: product.description}}
                />
            </div>

            <div className="mt-8 border-t border-gray-200 pt-8">
                <h2 className="text-sm font-medium text-gray-900">Materiały &amp; Ochrona</h2>

                <div className="prose prose-sm mt-4 text-gray-500">
                    <div role="list">
                        {(product.details || []).map((item: string) => (
                            <li key={item}>{item}</li>
                        ))}
                    </div>
                </div>
            </div>

            {/* Policies */}
            <section aria-labelledby="policies-heading" className="mt-10">
                <h2 id="policies-heading" className="sr-only">
                    Our Policies
                </h2>

                <dl className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2">
                    {(product.policies || []).map((policy: ProductPolicy) => (
                        <div key={policy.name}
                             className="rounded-lg border border-gray-200 bg-gray-50 p-6 text-center">
                            <dt>
                                <FontAwesomeIcon icon={policy.icon}
                                                 className="mx-auto h-6 w-6 flex-shrink-0 text-gray-400"
                                                 aria-hidden="true"/>
                                <span className="mt-4 text-sm font-medium text-gray-900">{policy.name}</span>
                            </dt>
                            <dd className="mt-1 text-sm text-gray-500">{policy.description}</dd>
                        </div>
                    ))}
                </dl>
            </section>
        </>
    );
}